export default "__VITE_ASSET__0e634e70__"